export default __webpack_public_path__ + "8391602e2d03536d3a667a3e250d0305.svg";